<template>
  <component
    :class="className"
    :is="component"
    @click="handleClick"
  >
    <slot />

    <q-tooltip v-if="hasTooltip">
      {{ tooltip }}
    </q-tooltip>
  </component>
</template>

<script>
import MicrophoneIcon from '../assets/icons/microphone.svg'
import SoundIcon from '../assets/icons/sound.svg'
import PauseIcon from '../assets/icons/pause.svg'
import TransferIcon from '../assets/icons/transfer.svg'
import ConferenceIcon from '../assets/icons/conference.svg'
import ChatAvatarIcon from '../assets/icons/chat-avatar.svg'
import RecordIcon from '../assets/icons/record.svg'
import PhoneIcon from '../assets/icons/phone.svg'
import MessageIcon from '../assets/icons/message.svg'
import CallIcon from '../assets/icons/call.svg'
import HangupIcon from '../assets/icons/hangup.svg'
import DialerIcon from '../assets/icons/dialer.svg'
import ExitIcon from '../assets/icons/exit.svg'
import ArrowDownIcon from '../assets/icons/arrowDown.svg'
import ArrowRightIcon from '../assets/icons/arrowRight.svg'
import ArrowLeftIcon from '../assets/icons/arrowLeft.svg'
import ArrowAgainstIcon from '../assets/icons/arrowAgainst.svg'
import BackIcon from '../assets/icons/back.svg'
import FaceAgentIcon from '../assets/icons/faceAgent.svg'
import PersonIcon from '../assets/icons/person.svg'
import ErrorIcon from '../assets/icons/error.svg'
import ListIcon from '../assets/icons/menu.svg'
import AttendanceIcon from '../assets/icons/attendance.svg'
import InternetIcon from '../assets/icons/internet.svg'
import internetDisconectedIcon from '../assets/icons/internetDisconected.svg'
import HistoricIcon from '../assets/icons/historic.svg'
import SettingsIcon from '../assets/icons/settings.svg'
import HelpIcon from '../assets/icons/help.svg'
import ReachableIcon from '../assets/icons/reachable.svg'
import UnreachableIcon from '../assets/icons/unreachable.svg'
import VonixLogoIcon from '../assets/icons/vonixLogo.svg'
import PhoneReceptionIcon from '../assets/icons/phoneReception.svg'
import SearchIcon from '../assets/icons/search.svg'
import MoreOptionsIcon from '../assets/icons/moreOptions.svg'
import EditIcon from '../assets/icons/edit.svg'
import DownloadIcon from '../assets/icons/download.svg'
import ChevronRight from '../assets/icons/chevron-right.svg'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false,
      default: 'col'
    },
    click: {
      type: Function,
      required: false
    }
  },
  components: {
    microphone: MicrophoneIcon,
    pause: PauseIcon,
    sound: SoundIcon,
    transfer: TransferIcon,
    conference: ConferenceIcon,
    record: RecordIcon,
    hangup: HangupIcon,
    dialer: DialerIcon,
    exit: ExitIcon,
    phone: PhoneIcon,
    message: MessageIcon,
    call: CallIcon,
    arrowDown: ArrowDownIcon,
    arrowRight: ArrowRightIcon,
    arrowLeft: ArrowLeftIcon,
    arrowAgainst: ArrowAgainstIcon,
    back: BackIcon,
    error: ErrorIcon,
    list: ListIcon,
    attendance: AttendanceIcon,
    internet: InternetIcon,
    internetDisconected: internetDisconectedIcon,
    historic: HistoricIcon,
    settings: SettingsIcon,
    help: HelpIcon,
    reachable: ReachableIcon,
    unreachable: UnreachableIcon,
    vonixLogo: VonixLogoIcon,
    chatAvatar: ChatAvatarIcon,
    faceAgent: FaceAgentIcon,
    person: PersonIcon,
    phoneReception: PhoneReceptionIcon,
    search: SearchIcon,
    moreOptions: MoreOptionsIcon,
    edit: EditIcon,
    download: DownloadIcon,
    chevronRight: ChevronRight
  },

  data () {
    return {
      component: this.name
    }
  },

  computed: {
    hasTooltip () {
      return typeof this.tooltip === 'string'
    }
  },

  methods: {
    handleClick: function () {
      return this.click ? this.click() : () => {}
    }
  }
}
</script>
<style lang="sass" scoped>
  @import '@/styles/quasar.variables.scss'

  .vonix-orange > path
    fill: #FE6600

  .highlight > path
    fill: #000

  .white > path
    fill: #FFF

  .blue-grey-7 > path
    fill: #133651

  .st-blue-grey-7 > path
    stroke: #133651

  .blue-grey-10 > path
    fill: #263238

  .connected > path
    fill: green

  .disconnected > path
    fill: red

  .sender > circle
    fill: #165A9F

  .recipient > circle
    fill: #FE6600

  .default > path
    fill: #90A4AE

  .hover-grey
    &:hover
      cursor: pointer

  .size-12
    width: 12px
    height: 12px

  .size-16
    width: 16px
    height: 16px

  .size-18
    width: 18px
    height: 18px

  .size-20
    width: 20px
    height: 20px

  .size-24
    width: 24px
    height: 24px

  .size-36
    width: 36px
    height: 36px

  .header-logo
    width: 50px
    height: 37px

  .size-24 > path
    fill: $blue-grey-10

  .small
    width: 20px
    height: 20px
    margin: 10px

  .medium
    width: 35px
    height: 35px
    margin: 0 10px
</style>
